import { render, staticRenderFns } from "./caseClosed.vue?vue&type=template&id=b9eb0532&scoped=true&"
import script from "./caseClosed.vue?vue&type=script&lang=js&"
export * from "./caseClosed.vue?vue&type=script&lang=js&"
import style0 from "./caseClosed.vue?vue&type=style&index=0&id=b9eb0532&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9eb0532",
  null
  
)

export default component.exports